import { render, staticRenderFns } from "./state-list.vue?vue&type=template&id=8d1a655a&scoped=true&"
import script from "./state-list.vue?vue&type=script&lang=js&"
export * from "./state-list.vue?vue&type=script&lang=js&"
import style0 from "./state-list.vue?vue&type=style&index=0&id=8d1a655a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1a655a",
  null
  
)

export default component.exports